import RadioButton from '../../../shared/RadioButton';
import { useTranslation } from 'react-i18next';
import {useEffect} from "react";
import Header from "../../../shared/Header";
import {Stack} from "../../../shared/layouts";

const AppointmentTypeStep = ({
  location_type,
  appointment_type_id,
  appointmentTypes,
  handleChangeAppointment,
  setDisabled
}) => {
  const { t } = useTranslation();

  const availableAppointmentTypes = appointmentTypes
    .filter(type => location_type === type?.location_type);
  const appointmentTypesOptions = availableAppointmentTypes.map(type => ({ label: type?.public_name || type?.name, value: type?.id }));

  useEffect(() => {
    if (appointmentTypesOptions.length === 1) {
      handleChangeAppointment({
        target: { name: 'appointment_type_id', value: appointmentTypesOptions[0].value }
      });
    } else {
      handleChangeAppointment({
        target: { name: 'appointment_type_id', value: null }
      });
    }
  }, []);

  useEffect(() => {
    if (appointment_type_id) setDisabled(false);
  }, [appointment_type_id]);

  return (
    <Stack space={'l'}>
      <Header title={t('Wat voor soort gesprek zou je graag in willen plannen?')} variant={'section'} />
      <RadioButton
        autoFocus={appointmentTypesOptions.length === 1}
        name={'appointmentType'}
        value={appointment_type_id}
        onChange={value =>
          handleChangeAppointment({
            target: {
              name: 'appointment_type_id',
              value: Number(value)
            }
          })
        }
        options={appointmentTypesOptions}
      />
    </Stack>
  );
};

export default AppointmentTypeStep;
